import React from 'react';

interface Props {
  id: string;
  text: string;
  selectedId: string;
  clickId: Function;
}


const QuestionBadge: React.FC<Props> = (props: Props) => {

  let cls = "rounded-full border mb-2 mr-2 border-indigo-700 px-3 py-1 z-title3  cursor-pointer " +
    "hover:bg-indigo-700 text-center";
  if (props.selectedId === props.id) {
    cls += " bg-indigo-700";
  }

  return (
    <div
      onClick={() => props.clickId(props.id)}
      className={cls}
      style={{ minWidth: 92 }}
    >
      {props.text}
    </div>
  )
}

export default QuestionBadge;